var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6.25C9 5.83579 9.33579 5.5 9.75 5.5H14.25C14.6642 5.5 15 5.83579 15 6.25C15 6.66421 14.6642 7 14.25 7H9.75C9.33579 7 9 6.66421 9 6.25Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10.25C9 9.83579 9.33579 9.5 9.75 9.5H14.25C14.6642 9.5 15 9.83579 15 10.25C15 10.6642 14.6642 11 14.25 11H9.75C9.33579 11 9 10.6642 9 10.25Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1.25C5.98122 1.25 4.75 2.48122 4.75 4V21.5H2.75C2.33579 21.5 2 21.8358 2 22.25C2 22.6642 2.33579 23 2.75 23H21.25C21.6642 23 22 22.6642 22 22.25C22 21.8358 21.6642 21.5 21.25 21.5H19.25V4C19.25 2.48122 18.0188 1.25 16.5 1.25H7.5ZM17.75 21.5V4C17.75 3.30964 17.1904 2.75 16.5 2.75H7.5C6.80964 2.75 6.25 3.30964 6.25 4L6.25 21.5H8.75V16.5C8.75 14.9812 9.98122 13.75 11.5 13.75H12.5C14.0188 13.75 15.25 14.9812 15.25 16.5V21.5H17.75ZM13.75 21.5V16.5C13.75 15.8096 13.1904 15.25 12.5 15.25H11.5C10.8096 15.25 10.25 15.8096 10.25 16.5V21.5H13.75Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingX2);
export default __webpack_public_path__ + "static/media/BuildingX2.354f8fc3d3d1058f46df3a0dfbad2c41.svg";
export { ForwardRef as ReactComponent };